lmApp
  .service('BillingService', ['$q', 'ApiService',
    function ($q, ApiService) {
      var service = {};

      service.EbsStripeInstall = function (code, livemode) {
        var data = {
          code: code,
          livemode: +livemode
        };

        return ApiService.Request('1/services/ebs.stripe/install', 'POST', data);
      };

      service.EbsStripeUninstall = function () {
        return ApiService.Request('1/services/ebs.stripe/uninstall', 'POST');
      };

      service.GetBillingSubscriptions = function () {
        return ApiService.Request('1/billing/subscription', 'GET');
      };

      service.GetBillingSubscriptionsDetailsForPeriod = function (period_id) {
        var deferred = $q.defer();

        var url = '1/billing/subscription/period/bill?period_id=' + period_id;

        ApiService.Request(url, 'GET')
          .then(function (response) {
            deferred.resolve(response.bill);
          }, function (reason) {
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.GetInvoicePreview = function (period_id) {
        var deferred = $q.defer();

        var url = '1/billing/subscription/period/invoice/preview?period_id=' + period_id;

        ApiService.Request(url, 'GET')
          .then(function (response) {
            deferred.resolve(response.invoice);
          }, function (reason) {
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.GetPaypalExpress = function () {
        var data = window.localStorage['paypal-express'];
        if (!data || data === 'undefined') {
          data = {
            paypal_user: 'name_api1.sotal.tv',
            paypal_password: '8GKU8V79L9HF54DN',
            paypal_password2: '8GKU8V79L9HF54DN',
            paypal_signature: 'AFcWxV21C7fd0v3bYYYRCpSSRl31Awm.Hu-Cx8jaJLTL9AS9kUFSPbtN'
          };
        } else {
          data = JSON.parse(data);
        }

        return data;
      };

      service.SavePaypalExpress = function (data) {
        window.localStorage['paypal-express'] = JSON.stringify(data);
      };

      service.GavePaypalPayflow = function () {
        var data = window.localStorage['paypal-payflow'];
        if (!data || data === 'undefined') {
          data = {
            payflow_partner: 'PayPalCA',
            payflow_vendor: 'sotalcloud',
            payflow_user: 'sotalcloud',
            payflow_password: 'am3xsWag4smOh'
          };
        } else {
          data = JSON.parse(data);
        }

        return data;
      };

      service.SavePaypalPayflow = function (data) {
        window.localStorage['paypal-payflow'] = JSON.stringify(data);
      };

      return service;
    }]);
